import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonus_1Screen } from "../SpinAndHold/SpinAndHold_1Screen";
import { BigSymbolSpinAndHoldBonus_1Screen } from "./BigSymbolSpinAndHoldBonus_1Screen";
import { BigSymbolSpinAndHoldBonusFactory } from "./BigSymbolSpinAndHoldFactory";

export class BigSymbolSpinAndHoldBonusFactory_1Screen extends BigSymbolSpinAndHoldBonusFactory
{
	public CreateBigSymbolSpinAndHoldBonus1_Screen(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus_1Screen
	{
		return new BigSymbolSpinAndHoldBonus_1Screen(gameName, params, config);
	}
}

